import theme from 'src/theme';

export const filtersSx = {
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        p: 1.5,
        bgcolor: theme.palette.common.white,
        borderRadius: '12px',
        border: `1px solid ${theme.palette.neutral[100]}`,
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    divider: {
        width: 1,
        height: 24,
        bgcolor: theme.palette.neutral[200],
    },
    chip: {
        borderRadius: '8px',
        fontSize: '0.78rem',
        fontWeight: 500,
        height: 32,
        border: `1px solid ${theme.palette.neutral[200]}`,
        bgcolor: theme.palette.common.white,
        color: theme.palette.neutral[700],
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
            borderColor: theme.palette.primary.light,
            bgcolor: 'rgba(0, 127, 220, 0.03)',
        },
    },
    chipActive: {
        borderRadius: '8px',
        fontSize: '0.78rem',
        fontWeight: 600,
        height: 32,
        border: `1px solid ${theme.palette.primary.main}`,
        bgcolor: 'rgba(0, 127, 220, 0.08)',
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    label: {
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.palette.neutral[500],
        mr: 0.5,
    },
    dateBtn: {
        textTransform: 'none',
        borderRadius: '8px',
        fontSize: '0.82rem',
        fontWeight: 500,
        color: theme.palette.neutral[700],
        border: `1px solid ${theme.palette.neutral[200]}`,
        bgcolor: theme.palette.common.white,
        height: 32,
        px: 1.5,
        '&:hover': {
            borderColor: theme.palette.primary.light,
            bgcolor: 'rgba(0, 127, 220, 0.03)',
        },
    },
    // Below md the bar is three stacked rows rather than one wrapping line. The keys above are shared
    // with other screens, so the phone gets its own rather than a breakpoint inside theirs.
    phoneRoot: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    // The drawing's three one-tap answers, equal thirds of the width.
    phonePresetRow: {
        display: 'flex',
        gap: '8px',
        '& > *': {
            flexGrow: 1,
            flexBasis: 0,
            minWidth: 0,
        },
    },
    // Everything the three chips do not cover, kept in reach: the remaining preset and the calendar.
    phoneSecondaryRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    phoneEnergyRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
    },
    // 44px because it is the floor for anything a finger has to hit, and 12px because that is the
    // control radius the kit gives every other control on a phone.
    phoneChip: {
        height: 44,
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.neutral[600],
        bgcolor: theme.palette.common.white,
        border: `1px solid ${theme.palette.neutral[200]}`,
        cursor: 'pointer',
        '& .MuiChip-label': {
            px: 1.25,
        },
        '&:hover': {
            bgcolor: theme.palette.common.white,
            borderColor: theme.palette.primary.light,
        },
    },
    phoneChipActive: {
        height: 44,
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: 600,
        color: theme.palette.common.white,
        bgcolor: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        cursor: 'pointer',
        '& .MuiChip-label': {
            px: 1.25,
        },
        '&:hover': {
            bgcolor: theme.palette.primary.dark,
        },
    },
    phoneDateBtn: {
        flexGrow: 1,
        minWidth: 0,
        height: 44,
        borderRadius: '12px',
        textTransform: 'none',
        fontSize: '13px',
        fontWeight: 500,
        color: theme.palette.neutral[600],
        bgcolor: theme.palette.common.white,
        border: `1px solid ${theme.palette.neutral[200]}`,
        px: 1.5,
        '&:hover': {
            bgcolor: theme.palette.common.white,
            borderColor: theme.palette.primary.light,
        },
    },
};
